import { FC } from 'react';

import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { BiXCircle } from 'react-icons/bi';


interface LimparBotaoPequenoProps {
  onClick: () => void;
  title?: string;
}

export const LimparBotaoPequeno: FC<LimparBotaoPequenoProps> = ({onClick, title}) => {
  return <Botaozinho
    as={BiXCircle}
    onClick={onClick}
    title={title ?? 'Limpar'} />
}

const Botaozinho = styled.div`
  min-height: 18px;
  min-width: 18px;
  margin-left: ${Spacing.unit/2}px;
  vertical-align: middle;
  cursor: pointer;
`;